import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { useEffect } from 'react';
import { useVerifyDomainMutation } from 'store/api/version-api.slice';

import VerificationResultForm from './VerificationResultForm';

const VerifyDomainDialog = ({ isOpen, onClose }) => {
	const [verifyDomain, { data: verificationResponse, isLoading }] = useVerifyDomainMutation();

	useEffect(() => {
		if (isOpen) {
			verifyDomain();
		}
	}, [verifyDomain, isOpen]);

	return (
		<Dialog open={isOpen} onClose={onClose} maxWidth={'md'} fullWidth={true}>
			<DialogTitle>Verify Domain</DialogTitle>
			<DialogContent
				sx={{
					minHeight: '200px',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}}
			>
				{isLoading ? (
					<CircularProgress size="50px" />
				) : (
					<VerificationResultForm result={verificationResponse?.result} />
				)}
			</DialogContent>
			<DialogActions
				sx={{
					padding: '8px 24px 16px'
				}}
			>
				<Button onClick={onClose} variant="contained" color="primary">
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default VerifyDomainDialog;
